import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MemberDirectoryComponent } from './member-directory/member-directory.component';
import { MemberProfileComponent } from './member-directory/member-profile.component';
import { ApiClient } from '../../core/api-client.service';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ViewMemberLocationsModalComponent } from './modals/view-member-locations-modal.component';
import { RouterModule } from '@angular/router';
import { MemberNewsFeedComponent } from './member-news/member-news-feed.component';
import { MemberDiscountsComponent } from './member-discounts/member-discounts.component';
import { ClaimMemberDiscountComponent } from './member-discounts/claim-member-discount.component';
import { MemberNewsArticleComponent } from './member-news/member-news-article.component';
import { IntroduceYourselfModalComponent } from './modals/introduce-yourself-modal.component';
import { MemberAccountComponent } from './member-account/member-account.component';
import { EditorModule } from '@tinymce/tinymce-angular';
import { ResourcesDirectoryListComponent } from './member-resources/resources-list.component';
import { ResourcePageDetailsComponent } from './member-resources/resource-details.component';
import { NgbPagination } from '@ng-bootstrap/ng-bootstrap';


@NgModule({
  declarations: [
    MemberDirectoryComponent,
       MemberProfileComponent,
       ViewMemberLocationsModalComponent,
       MemberNewsFeedComponent,
       MemberDiscountsComponent,
       ClaimMemberDiscountComponent,
       MemberNewsArticleComponent,
       IntroduceYourselfModalComponent,
       MemberAccountComponent,
       ResourcesDirectoryListComponent,
       ResourcePageDetailsComponent
  ],
  imports: [
    CommonModule,
      FormsModule,
      ReactiveFormsModule,
      RouterModule,
      EditorModule,
      NgbPagination
  ],
    providers: [ApiClient],
})
export class MemberInformationModule { }
